import React from "react"
import { useEffect, useState } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import { TextField, Button, Autocomplete, Box } from "@mui/material"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import {
  ApiAddAreaManager,
  ApiGetClientDbName,
  ApiGetClientEntityListById,
  ApiGetClients,
  ApiGetVenueList,
  ApiUpdateAreaManager,
} from "../../../apiService/Core/Apicall.tsx"
import { toast } from "react-toastify"

interface AreaFormProps {
  initialValues?: {
    areaName: string
    userName: string
    password: string
    venueList: string[]
    email: string
  }
  onSubmit: (values: any) => void
  mode: "add" | "update"
}
const AddOrUpdateAreaManager: React.FC<AreaFormProps> = ({
  initialValues = {
    areaName: "",
    userName: "",
    password: "",
    venueList: [],
    email: "",
  },
  onSubmit,
}) => {
  const location = useLocation()
  const areaManager = location?.state?.areaManager
  const [venues, setVenues] = useState<any[]>([])
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const { mode, id } = useParams<{ mode: "add" | "update"; id?: string }>()
  const [clientGroupOptions, setClientGroupOptions] = useState([])
  const [clientOptions, setClientOptions] = useState<any[]>([])
  const [selectedClientGroup, setSelectedClientGroup] = useState()
  const [clientEntities, setClientEntities] = useState([])
  const [clientId, setClientId] = useState<string | null>(null)
  const [clientEntityId, setClientEntityId] = useState<string | null>(null)

  console.log(areaManager)
  useEffect(() => {
    if (mode === "update" && id) {
      console.log(`Fetching data for area with ID: ${id}`)
      // Here you would fetch the area manager data for editing
      // Example: fetchAreaManagerById(id);
    }
  }, [mode, id])

  useEffect(() => {
    if (mode === "update" && id) {
      console.log(`Fetching data for client with ID: ${id}`)
    }
    handleCallGetClientDbName()
  }, [mode, id])

  useEffect(() => {
    if (areaManager && mode === "update") {
      // Set form values
      formik.setValues({
        areaName: areaManager.areaName || "",
        userName: areaManager.userName || "",
        password: "", // Usually don't pre-fill password fields for security
        email: areaManager.emailId || "",
        venueList: areaManager.venueIds ? areaManager.venueIds.split(",").map((id) => id.trim()) : [],
      })

      // Find and set client group
      if (areaManager.clientGroupName) {
        const clientGroup = clientGroupOptions.find((group) => group.clientGroupName === areaManager.clientGroupName)
        if (clientGroup) {
          setSelectedClientGroup(clientGroup)
          fetchClientsByGroup(clientGroup.clientGroupName)
        }
      }

      // Set client ID
      if (areaManager.ClientID) {
        setClientId(areaManager.ClientID)
        fetchBusinessesByClient(areaManager.ClientID)
      }

      // Set client entity ID
      if (areaManager.clientEntityId) {
        setClientEntityId(areaManager.clientEntityId)
        fetchVenues(areaManager.clientEntityId)
      }
    }
  }, [areaManager, mode, clientGroupOptions])

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      areaName: Yup.string().required("Area Name is required"),
      userName: Yup.string().required("User Name is required"),
      email: Yup.string().email("Invalid email format").required("Email is required"),
      venueList: Yup.array().min(1, "At least one venue must be selected"),
    }),
    onSubmit: async (values) => {
      const formData = {
        areaName: values.areaName,
        clientEntityId: clientEntityId,
        userName: values.userName,
        clientId: clientId,
        emailId: values.email,
        venueIds: values.venueList.join(","),
      }

      setLoading(true)
      setError(null)

      try {
        if (mode === "add") {
          console.log(formData)
          // Call API to add a new area manager
          const response = await ApiAddAreaManager(formData)
          toast.success("Area Manager added successfully!")
          navigate(-1) // Redirect to the area managers list page
        } else if (mode === "update" && id) {
          const data = {
            areaId: areaManager.areaId,
            areaName: values.areaName,
            clientEntityId: clientEntityId,
            userName: values.userName,
            emailId: values.email,
            venueIds: values.venueList.join(","),
            modifiedBy: Number(localStorage.getItem('createdBy'))
          }
          // Call API to update an existing area manager
          await ApiUpdateAreaManager(data);
          toast.success("Area Manager updated successfully!")
          navigate(-1) // Redirect to the area managers list page
        }
      } catch (error) {
        console.error("Error during API call:", error)
        setError(error?.response?.data.message || "An error occurred")
        toast.error(error?.response?.data.message || "Failed to save Area Manager")
      } finally {
        setLoading(false)
      }
    },
  })

  const handleCallGetClientDbName = async () => {
    try {
      {
        const response = await ApiGetClientDbName()
        setClientGroupOptions(response.data)
      }
    } catch (error) {
      console.error("Error during API call:", error)
      toast.error(`${error}`)
    }
  }

  const fetchBusinessesByClient = async (clientId: any) => {
    const data = `?clientId=${clientId}`
    try {
      const response: any = await ApiGetClientEntityListById(data)
      setClientEntities(response.data)
      console.log("Business response:", response.data)
    } catch (error) {
      console.error("Failed to fetch businesses:", error)
      toast.error("Failed to fetch businesses")
    }
  }

  console.log(venues)

  const fetchClientsByGroup = async (clientGroup: string) => {
    const data = `?status=active&clientGroup=${clientGroup}`
    try {
      const response = await ApiGetClients(data)

      setClientOptions(response.data)
    } catch (error) {
      console.error("Failed to fetch clients:", error)
      toast.error("Failed to fetch clients")
    }
  }
  console.log(formik.values.venueList)

  const fetchVenues = async (clientEntityId) => {
    try {
      const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500`
      const res = await ApiGetVenueList(data)
      setVenues(res.data) // Ensure options are set correctly
    } catch (error) {
      console.error("Error fetching venues:", error)
    }
  }

  return (
    <Box
      component="form"
      onSubmit={formik.handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: 800,
        margin: "auto",
        padding: 3,
        backgroundColor: "#f9f9f9",
        borderRadius: 2,
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <h1>{mode === "add" ? "Add New Area Manager" : "Update Area Manager"}</h1>

      <div>
        <Autocomplete
          options={clientGroupOptions}
          value={
            selectedClientGroup ||
            (areaManager?.clientGroup
              ? clientGroupOptions.find((option: any) => option.clientGroupName === areaManager.clientGroup)
              : null)
          }
          getOptionLabel={(option: any) => option?.clientGroupName || ""}
          onChange={(event, newValue) => {
            setSelectedClientGroup(newValue)
            if (newValue) {
              fetchClientsByGroup(newValue.clientGroupName)
            } else {
              setClientOptions([])
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Client Group" />}
          fullWidth
        />
      </div>
      <div>
        <Autocomplete
          options={clientOptions}
          value={clientId ? clientOptions.find((option) => option.ClientID === clientId) : null}
          getOptionLabel={(option) => option?.ClientName || ""}
          onChange={(event, newValue) => {
            if (newValue) {
              setClientId(newValue.ClientID)
              fetchBusinessesByClient(newValue.ClientID)
            } else {
              setClientId(null)
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Client" />}
          fullWidth
        />
      </div>
      <div>
        <Autocomplete
          options={clientEntities}
          value={clientEntityId ? clientEntities.find((option: any) => option.clientEntityId === clientEntityId) : null}
          getOptionLabel={(option: any) => option?.entityName || ""}
          onChange={(event, newValue) => {
            if (newValue) {
              setClientEntityId(newValue.clientEntityId)
              fetchVenues(newValue.clientEntityId)
            } else {
              setClientEntityId(null)
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Business" />}
          fullWidth
        />
      </div>
      <TextField
        label="Area Name"
        name="areaName"
        value={formik.values.areaName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.areaName && Boolean(formik.errors.areaName)}
        helperText={formik.touched.areaName && formik.errors.areaName}
        fullWidth
      />
      <TextField
        label="User Name"
        name="userName"
        value={formik.values.userName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.userName && Boolean(formik.errors.userName)}
        helperText={formik.touched.userName && formik.errors.userName}
        fullWidth
      />
      <TextField
        label="Email ID"
        name="email"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.email && Boolean(formik.errors.email)}
        helperText={formik.touched.email && formik.errors.email}
        fullWidth
      />
      <Autocomplete
        multiple
        options={venues || []}
        getOptionLabel={(option) => option?.venueName || ""}
        value={
          formik.values.venueList && venues.length > 0
            ? venues.filter(
                (venue) =>
                  formik.values.venueList.includes(venue.venueId) ||
                  formik.values.venueList.includes(String(venue.venueId)),
              )
            : []
        }
        onChange={(event, value) => {
          const selectedValues = value.map((item) => item.venueId)
          formik.setFieldValue("venueList", selectedValues)
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Venue List"
            error={formik.touched.venueList && Boolean(formik.errors.venueList)}
            helperText={formik.touched.venueList && formik.errors.venueList}
          />
        )}
        fullWidth
      />

      <div style={{ color: "red" }}>{error}</div>
      <Button type="submit" variant="contained" color="primary" className="table-row-background" disabled={loading}>
        {loading ? "Saving..." : mode === "add" ? "Add Area" : "Update Area"}
      </Button>
    </Box>
  )
}

export default AddOrUpdateAreaManager
